export const SystemModule={
    namespaced:true,

    state:{
        system:{
            sub:false,
            c:"Customers",
            am:"Account Manager",
            oname:"",
            acct_type:""
        }
    },

    mutations:{
        SET_SYSTEM(state, system){
            state.system=system;
        }
    },

    actions:{
        setSystem({commit}, login){
            commit('SET_SYSTEM',login);
        }
    },
};